export enum QuestionType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  TRUE_FALSE = 'TRUE_FALSE',
  SHORT_ANSWER = 'SHORT_ANSWER',
}

export interface QuizOption {
  id: string;
  text: string;
  isCorrect?: boolean;
}

export interface QuizQuestion {
  id: string;
  question: string;
  type: QuestionType;
  options?: QuizOption[];
  correctAnswerText?: string;
  marks: number;
  explanation?: string;
}

export interface Quiz {
  _id: string;
  title: string;
  description?: string;
  liveClass: any;
  meetingId?: any;
  sessionDate?: Date | string;
  questions: QuizQuestion[];
  totalMarks: number;
  passingMarks?: number;
  durationMinutes?: number;
  maxAttempts?: number;
  isPublished: boolean;
  availableFrom?: Date | string;
  availableTo?: Date | string;
  dueDate?: Date | string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export interface QuestionBankItem {
  _id: string;
  instructor: any;
  question: string;
  type: QuestionType;
  options?: QuizOption[];
  correctAnswerText?: string;
  marks: number;
  explanation?: string;
  tags?: string[];
  createdAt?: Date | string;
}

export interface StudentAnswer {
  questionId: string;
  selectedOptionIds?: string[];
  answerText?: string;
  isCorrect?: boolean;
  scoreAwarded?: number;
}

export interface QuizSubmission {
  _id: string;
  quiz: Quiz | string;
  liveClass: any;
  user: any;
  attemptNumber: number;
  answers: StudentAnswer[];
  totalScore: number;
  passed: boolean;
  startedAt: Date | string;
  submittedAt?: Date | string;
  createdAt?: Date | string;
}
